import React from "react";
import TodoList from "./TodoList";

const CompletedTodos = () => {
  return (
    <>
      <div>
        <h1>Completed Todos</h1>
        <hr className='mt-4' />
      </div>
      <TodoList completed />
    </>
  );
};

export default CompletedTodos;
